import { render, staticRenderFns } from "./BaggageAbnormalCheckIn.vue?vue&type=template&id=8b31a566&scoped=true"
import script from "./BaggageAbnormalCheckIn.vue?vue&type=script&lang=js"
export * from "./BaggageAbnormalCheckIn.vue?vue&type=script&lang=js"
import style0 from "./BaggageAbnormalCheckIn.vue?vue&type=style&index=0&id=8b31a566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b31a566",
  null
  
)

export default component.exports